var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitrine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.359,
    height: 46.224,
    viewBox: "0 0 41.359 46.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vitrine",
    transform: "translate(-7.097 -4.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1455",
    "data-name": "Caminho 1455",
    d: "M13.739,50.393H41.815a6.674,6.674,0,0,0,6.634-6.985L47.1,17.134a1.656,1.656,0,0,0-.132-.4l-2.218-3.5a2.561,2.561,0,0,0-2.4-1.158l.148-.7a2.484,2.484,0,0,0-1.823-2.935L32.539,6.373A2.5,2.5,0,0,0,29.514,8.16l-.532,2.045-.916.23L27.8,7.212a3.338,3.338,0,0,0-3.69-3.023l-9,1.036a3.338,3.338,0,0,0-2.914,3.732l.412,3.146a1.745,1.745,0,0,0-1.686.812L8.637,16.752a1.871,1.871,0,0,0-.112.379l-1.42,26.26a6.674,6.674,0,0,0,6.634,7ZM41.988,13.731h.652a.827.827,0,0,1,.7.386l1.412,2.23H41.433ZM31.122,8.579a.832.832,0,0,1,1.008-.6l8.127,2.065a.828.828,0,0,1,.607.978l-1.129,5.32h-5l-1.157-4.714a2.468,2.468,0,0,0-2.771-1.86Zm-.161,2.842a.835.835,0,0,1,1.008.608l1.06,4.318H20.595c-.15-.785-.88-2.036.236-2.381ZM14.184,7.507A1.654,1.654,0,0,1,15.3,6.876l9-1.036a1.685,1.685,0,0,1,1.845,1.512l.292,3.494-6.008,1.509c-1.859.475-2.21,2.4-1.549,3.992H14.838l-1-7.605a1.656,1.656,0,0,1,.342-1.234Zm-1.836,6.257h.477l.338,2.582H10.811ZM8.764,43.481l1.377-25.474s35.333,0,35.337,0l1.313,25.486a4.983,4.983,0,0,1-4.976,5.239H13.739a5.006,5.006,0,0,1-4.976-5.251Z",
    transform: "translate(0 0)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1456",
    "data-name": "Caminho 1456",
    d: "M22.428,28.859v3.262a6.29,6.29,0,0,0,12.58,0V28.859a2.355,2.355,0,1,0-1.415,0v3.262a4.875,4.875,0,0,1-9.749,0V28.859a2.361,2.361,0,1,0-1.415,0ZM34.3,25.674a.945.945,0,1,1-.945.945.945.945,0,0,1,.945-.945Zm-11.164,0a.945.945,0,1,1-.945.945.945.945,0,0,1,.945-.945Z",
    transform: "translate(-0.943 -1.871)",
    fill: "#ffbe00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitrine);
export default __webpack_public_path__ + "static/media/vitrine.3d26add190173bb55bba8ed13d0a0bf7.svg";
export { ForwardRef as ReactComponent };